import { Box } from "@mui/material";
import { useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { toastOptionsAtom } from "../../../atoms";
import { InvoicePaymentInitiatePayload } from "../../../types";
import Loading from "../../common/loading/Loading";
import { useCashPaymentMutation } from "../../../api";

type Props = {
  payload: InvoicePaymentInitiatePayload | undefined;
  orgId: number;
};

export const CashPayment = ({ payload, orgId }: Props) => {
  const hasMutated = useRef(false);
  const [paymentCallbackUrl, setPaymentCallbackUrl] = useState<string>();
  const [, setToastOptions] = useAtom(toastOptionsAtom);
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const cashPaymentMutation = useCashPaymentMutation();

  useEffect(() => {
    if (payload && !hasMutated.current) {
      hasMutated.current = true;
      setTimeout(() => {
        cashPaymentMutation.mutate({
          orgId: orgId,
          accountId: payload.accountId,
          invoiceNumber: payload.invoiceNumber,
          amount: payload.invoiceAmount,
        });
      }, 100);
    }
  }, []);

  useEffect(() => {
    if (cashPaymentMutation.isSuccess) {
      const callBackUrl = cashPaymentMutation.data;
      setPaymentCallbackUrl(callBackUrl);
    }

    if (cashPaymentMutation.isError) {
      setToastOptions({
        open: true,
        message: "Something went wrong",
        severity: "error",
      });
    }
  }, [
    cashPaymentMutation.isSuccess,
    cashPaymentMutation.isError,
    cashPaymentMutation.isLoading,
    cashPaymentMutation.data,
    cashPaymentMutation.error,
  ]);

  return (
    <Box
      sx={{
        borderRadius: "10px",
        minHeight: "630px",
        py: "auto",
      }}
    >
      <iframe
        style={{
          height: "630px",
          width: "100%",
          border: "none",
        }}
        src={paymentCallbackUrl}
        onLoad={() => setIsIframeLoading(false)}
      ></iframe>
      {(cashPaymentMutation.isLoading || isIframeLoading) && (
        <Loading
          message=" "
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          }}
        />
      )}
    </Box>
  );
};
